import _ from 'lodash';

export default function SelecaoSistemaController(
  $q,
  $state,
  acessoService,
  promiseTracker,
  entidadeContextoHolder
) {
  const vm = this;
  vm.trackers = { carregando: promiseTracker() };

  (() => {
    const contextoAtual = entidadeContextoHolder.get();
    const promise = acessoService.getSistemasByEntidade(contextoAtual.values.entity)
      .then((sistemas) => {
        if (_.isEmpty(sistemas)) {
          $state.go('main.entidade');
          return $q.defer().promise;
        }

        vm.sistemas = sistemas;
      });

    vm.trackers.carregando.addPromise(promise);
    return promise;
  })();

  vm.selecionar = (sistema) => {
    const params = {
      APP_SYSTEM: sistema.id
    };

    let goPromise;

    if (sistema.urlSubcontext) {
      goPromise = $state.go('main.entidade.selected.sistema.selected.subcontexto', params);
    } else {
      goPromise = $state.go('main.entidade.selected.sistema.selected.visaoGeralSistema', params);
    }

    vm.trackers.carregando.addPromise(goPromise);
    return goPromise;
  };
}

SelecaoSistemaController.$inject = [
  '$q',
  '$state',
  'AcessoService',
  'promiseTracker',
  'EntidadeContextoHolderService',
];
